<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeName"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @workLink="workLinkFun"
        @marketLink="marketLinkFun"
        @otherLink="otherLinkFun"
        @backCenterLink="backCenterLinkFun"
        @leftLink="leftLinkFun"
        @usedLink="usedLinkFun"
      />
    </div>
    <view-dialog
      :select-item="selectItem"
      :view-type="viewType"
      :dialog-visible.sync="dialogVisible"
      dialog-title="查询物料信息"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 权限验证
import checkPermission from '@/utils/permission'
// 查看
import ViewDialog from './components/viewDialog'
// 数据请求
import { findOutdepotBillDetailListDataPageByStatisticsApi, exportOutdepotBillDetailListDataPageByStatisticsApi } from '@/api/outdepotBill'
export default {
  name: 'MaterialsUsedStatistics',
  components: {
    CustomTable,
    TableOperation,
    ViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'statistics_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ["materials_used_statistics_export"],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'db1.scheme_id', // 排序字段
            order: 'desc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            materialsName: '',
            schemeName: '',
            schemeNo: '',
            noViewSmoke: 0
          }
        },
        notPaging: true
      },
      dialogVisible: false,
      selectItem: null, // 选中行
      viewType: null // 查看明细类型
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'db1.scheme_name', width: 160 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'db1.scheme_no', width: 160 },
      { prop: 'provinceNames', label: '省区', filterColumn: 'db1.province_names', width: 110 },
      { prop: 'cityNames', label: '城市', filterColumn: 'db1.city_names', width: 110 },
      { prop: 'materialsName', label: '物料名称', filterColumn: 'db1.materials_name', width: 240 },
      { prop: 'amount', label: '方案数量', filterColumn: 'db1.amount', width: 110, isBetween: true },
      { prop: 'indepotAmount', label: '已入库数量', filterColumn: 'ifnull(db7.indepot_amount,0)', width: 110, isBetween: true },
      { prop: 'inventoryAmount', label: '当前库存', filterColumn: 'ifnull(db2.inventory_amount,0)', width: 110, isBetween: true },
      { prop: 'workAmount', label: '日常工作出库', filterColumn: 'ifnull(db3.work_amount,0)', width: 120, isBetween: true, isCustomLink: true, customLinkFun: 'workLink' },
      { prop: 'usedAmount', label: '已核销数量', filterColumn: 'ifnull(db8.used_amount,0)', width: 120, isBetween: true, isCustomLink: true, customLinkFun: 'usedLink' },
      { prop: 'marketAmount', label: 'QDYX1出库', filterColumn: 'ifnull(db4.market_amount,0)', width: 120, isBetween: true, isCustomLink: true, customLinkFun: 'marketLink' },
      { prop: 'otherAmount', label: '其它出库', filterColumn: 'ifnull(db5.other_amount,0)', width: 120, isBetween: true, isCustomLink: true, customLinkFun: 'otherLink' },
      { prop: 'backCenterAmount', label: 'QDYX2出库', filterColumn: 'ifnull(db9.back_center_amount,0)', width: 120, isBetween: true, isCustomLink: true, customLinkFun: 'backCenterLink' },
      { prop: 'workLeftAmount', label: '未核销数量', filterColumn: 'ifnull(db6.work_left_amount,0)', width: 120, isBetween: true, isCustomLink: true, customLinkFun: 'leftLink' }
    ]
    let noViewSmoke = 1
    if (checkPermission(['sample_smoke_view'])) {
      noViewSmoke = 0
    }
    this.masterList.tableQuery.search.noViewSmoke = noViewSmoke
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      findOutdepotBillDetailListDataPageByStatisticsApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    workLinkFun (rowData) {
      this.viewType = 1
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    marketLinkFun (rowData) {
      this.viewType = 2
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    otherLinkFun (rowData) {
      this.viewType = 3
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    backCenterLinkFun (rowData) {
      this.viewType = 6
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    leftLinkFun (rowData) {
      this.viewType = 4
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    usedLinkFun (rowData) {
      this.viewType = 5
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      exportOutdepotBillDetailListDataPageByStatisticsApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
